import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { withPrefix } from 'gatsby-link'
import speakerList from './data/data.json'
import StarIcon from './StarIcon'

class Speakers extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      speakers: speakerList,
      selectedIndex: Math.floor(Math.random() * Math.floor(speakerList.length)),
      updating: false
    };
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.setState({updating: false})
    }, 100);
  }

  activeSpeaker(id) {
    this.setState({
      selectedIndex: id,
      updating: true
    })
  }

  render() {
    const speakers = speakerList
    const updating = this.state.updating
    const selectedIndex = this.state.selectedIndex
    const name = !updating && speakers[this.state.selectedIndex].name

    return (
      <div className="speakers" id="speakers">
        <StarIcon />
        <h2 className="section-title">Speakers</h2>

        {speakerList.map(speaker => (
          <div key={speaker.id} className={`speaker-description ${updating ? 'updating ' : ''}${this.state.selectedIndex === speaker.id ? 'active' : 'hidden-lg'}`}>
            {/* <img className="speaker-description-image" src={speaker.img} alt={speaker.name} /> */}
            <div className="speaker-name-twitter-wrapper" >
              <span className="speaker-description-name">{speaker.name}</span>
              <TwitterLink twitter_handle={speaker.twitter_handle} />
            </div>
            <div>{ReactHtmlParser(speaker.description)}</div>
          </div>
        ))}

        <div className="speaker-list">
          {speakerList.map(speaker => ( <div
            className={`speaker-title item${selectedIndex === speaker.id ? ' active' : ''}`}
            key={speaker.id}
            onClick={() => selectedIndex !== speaker.id && this.activeSpeaker(speaker.id)}>
            <svg className="star-icon">
              <use xlinkHref="#star-icon" />
            </svg>
            <span className="speaker-name">{speaker.name}</span>
          </div> ))}
        </div>
      </div>
    )
  }
}

const TwitterLink = ({ twitter_handle = '', className=''}) => {
  const sanitizeTwitterHandle = twitterUser => {
    return twitterUser.charAt(0) === '@' ? twitterUser.substring(1) : twitterUser
  }
  const twitterUrl = twitter_handle &&
    `https://twitter.com/${sanitizeTwitterHandle(twitter_handle)}`
  return (
    <a href={twitterUrl} target="_blank" className={`twitter-link ${className}`}>
      <svg className="twitter-logo twitter-link-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><title>Twitter Logo</title><rect fill="none" width="400" height="400" /><path fill="#1da1f2" d="M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23" /></svg>
      <span className="twitter-link-text" >{twitter_handle}</span>
    </a>
  )
}

export default Speakers


// WEBPACK FOOTER //
// ./src/components/Speakers/index.js